var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrap",class:_vm.shape,style:(_vm.wrapStyle)},[_c('div',{staticClass:"progress-bg",style:(_vm.bgStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }